export enum CURSOR_TYPE {
    resting = 'resting',
    engagedSmall = 'engaged-small',
    engagedLarge = 'engaged-large',
    line = 'line',
}
